import React from 'react';

/**
 * Intercepte les ChunkLoadError (chunk JS non disponible hors ligne)
 * et affiche un message clair à l'utilisateur.
 * IMPORTANT : n'utilise pas window.location.reload() pour ne pas détruire
 * la session hors ligne. Utilise onBack (navigate(-1)) si disponible.
 */
export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasChunkError: false };
  }

  static getDerivedStateFromError(error) {
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module') ||
      error?.message?.includes('Importing a module script failed');
    return { hasChunkError: isChunkError };
  }

  componentDidCatch(error) {
    if (!this.state.hasChunkError) return;
    console.warn('[ChunkErrorBoundary] Chunk non disponible hors ligne:', error?.message);
  }

  handleBack() {
    // Réinitialiser l'erreur puis reculer dans l'historique (pas de reload)
    this.setState({ hasChunkError: false });
    try { window.history.back(); } catch {}
  }

  render() {
    if (this.state.hasChunkError) {
      return (
        <div style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg,#0b1220,#1a2540)',
          padding: 24,
          gap: 16,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 48 }}>📶</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#e1e6ef' }}>
            Page non disponible hors ligne
          </div>
          <div style={{ color: '#94a3b8', maxWidth: 380, lineHeight: 1.6 }}>
            Ce module n'a pas encore été mis en cache.
            Connectez-vous à internet, visitez cette page une fois, puis elle sera disponible hors ligne.
          </div>
          <button
            onClick={() => this.handleBack()}
            style={{
              background: 'linear-gradient(135deg,#6366f1,#4f46e5)',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              padding: '10px 28px',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            ← Retour
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
